import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Spinner from '../../../components/UI/Spinner/Spinner';
import { interviewRoleMap } from '../../../helperFunctions';
import { setCurrentInterviewPage } from '../../../store/actions';
import { history } from '../../../index';
import InterviewContainer from '../InterviewContainer';
import NonTechnicalInterviewContainer from '../NonTechnicalInterviewContainer';
import ScreenShareModel from '../../Interview/ScreenShare/ScreenShareModel';
import WaitingRoom from '../../../components/WaitingLobby/WaitingRoom';
import ScreenShareView from './ScreenShareView';
import { leaveMeeting } from '../../../Utils/utils';
import style from './MeetingContainer.scss';

const MeetingContainer = props => {
  const dispatch = useDispatch();

  const { meeting } = useSelector(state => state);
  const { meetingSession, videoStream, audioStream, screenStream } = useSelector(
    state => state.interviewRecording,
  );
  const { role, interview_type } = useSelector(state => state.interview);
  const current_page = meeting.current_page || 'device-setup';

  console.log('LET SEE THE INTERVIEW TYPE', interview_type);

  let urlparams = new URLSearchParams(window.location.search);
  let interview_id = urlparams.get('interview_id');

  useEffect(() => {
    dispatch(setCurrentInterviewPage('device-setup'));
  }, []);

  async function handleEndMeeting(isDeveloper) {
    if (isDeveloper) {
      leaveMeeting(meetingSession, dispatch);
      history.push(`/interview/feedback?interview_id=${interview_id}`);
    }
  }

  const isDeveloper = role === 'DE';

  return (
    <>
      {current_page === 'device-setup' && (
        <div className={style['meeting-container']}>
          <ScreenShareModel interview_id={interview_id} />
        </div>
      )}
      {current_page === 'waiting_lobby' && <WaitingRoom />}
      {current_page === 'meeting' && interview_type === 'TE' && (
        <InterviewContainer
          endMeeting={handleEndMeeting}
          endInterview={props.endInterview}
        />
      )}
      {current_page === 'meeting' && interview_type === 'NT' && (
        <NonTechnicalInterviewContainer
          endMeeting={handleEndMeeting}
          endInterview={props.endInterview}
        />
      )}
      {current_page === 'screen-share-view' && <ScreenShareView />}
      {!current_page && <Spinner />}
    </>
  );
};

export default MeetingContainer;
